import { render } from "./IsLoading.vue?vue&type=template&id=2b2cc8aa"
import script from "./IsLoading.vue?vue&type=script&lang=js"
export * from "./IsLoading.vue?vue&type=script&lang=js"

import "./IsLoading.vue?vue&type=style&index=0&id=2b2cc8aa&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\projects\\gvnpro\\supportgroup\\head.supportgroup\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__